import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packingSlipWarningMessage: {
    description: 'bulkErrorsAndWarningsService.packingSlipWarningMessage',
    defaultMessage: 'Some of the selected items have packing slips printed. Would you like to reprint the packing slips?',
    id: 'ME4Crr',
  },
  labelCreateErrors: {
    description: 'bulkErrorsAndWarningsService.labelCreateErrors',
    defaultMessage: 'There were some problems creating labels for the orders you selected. Please fix the following issues',
    id: 'SAq0Nz',
  },
  labelCreateWarnings: {
    description: 'bulkErrorsAndWarningsService.labelCreateWarnings',
    defaultMessage: 'Some of the selected shipments have warnings. View them below.',
    id: 'KGOz4n',
  },
  packingSlipPrinted: {
    description: 'bulkErrorsAndWarningsService.packingSlipPrinted',
    defaultMessage: 'Packing Slip Printed',
    id: '5SZGPI',
  },
  printWarnings: {
    description: 'bulkErrorsAndWarningsService.printWarnings',
    defaultMessage: 'Print Warnings',
    id: 'HzjvMO',
  },
  labelErrors: {
    description: 'bulkErrorsAndWarningsService.labelErrors',
    defaultMessage: 'Label Errors',
    id: 'Ils6vl',
  },
  labelWarnings: {
    description: 'bulkErrorsAndWarningsService.labelWarnings',
    defaultMessage: 'Label Warnings',
    id: '5oYz9o',
  },
  labelWarningMessage: {
    description: 'bulkErrorsAndWarningsService.labelWarningMessage',
    defaultMessage: 'Some of the selected labels have already been printed. Would you like to reprint them?',
    id: 'JEB1lJ',
  },
  labelPrinted: {
    description: 'bulkErrorsAndWarningsService.labelPrinted',
    defaultMessage: 'Label Printed',
    id: 'pwzbkY',
  },
  customsFormsErrors: {
    description: 'bulkErrorsAndWarningsService.customsFormsErrors',
    defaultMessage: 'Customs Forms Errors',
    id: '8OlE8+',
  },
  missingCustomsDeclarationsTitle: {
    description: 'bulkErrorsAndWarningsService.missingCustomsDeclarationsTitle',
    defaultMessage: 'Some of the selected shipments have missing Customs Declarations.',
    id: 'YX02rD',
  },
  missingCustomsDeclarations: {
    description: 'bulkErrorsAndWarningsService.missingCustomsDeclarations',
    defaultMessage: 'Missing Customs Declarations.',
    id: 'fg3mIC',
  },
  customsMissingLabelTitle: {
    description: 'bulkErrorsAndWarningsService.customsMissingLabelTitle',
    defaultMessage: 'Some of the selected shipments do not have Customs Forms because the label has not been purchased.',
    id: '1xbTEY',
  },
  customsMissingLabel: {
    description: 'bulkErrorsAndWarningsService.customsMissingLabel',
    defaultMessage: 'Label has not been purchased',
    id: 'RB+Dzz',
  },
  customsNotRequiredTitle: {
    description: 'bulkErrorsAndWarningsService.customsNotRequiredTitle',
    defaultMessage: 'Some of the selected shipments do not have Customs Forms because they are domestic shipments.',
    id: 'MaTE0z',
  },
  customsNotRequired: {
    description: 'bulkErrorsAndWarningsService.customsNotRequired',
    defaultMessage: 'Domestic Shipment',
    id: 'c8zgg+',
  },
  customsOnLabelTitle: {
    description: 'bulkErrorsAndWarningsService.customsOnLabelTitle',
    defaultMessage: 'Some of the selected shipments have Customs Forms attached to their shipping labels and cannot be included.',
    id: 'zu2BHY',
  },
  customsOnLabel: {
    description: 'bulkErrorsAndWarningsService.customsOnLabel',
    defaultMessage: 'Customs Forms attached to label',
    id: 'S5/u37',
  },
  singleCustomsErrorTitle: {
    description: 'bulkErrorsAndWarningsService.singleCustomsErrorTitle',
    defaultMessage: 'Print Error',
    id: '9ocaoX',
  },
  singleCustomsErrorMissingDeclarations: {
    description: 'bulkErrorsAndWarningsService.singleCustomsErrorMissingDeclarations',
    defaultMessage: 'This shipment is missing Customs Declarations.',
    id: 'ybM4Hp',
  },
  singleCustomsErrorNoLabel: {
    description: 'bulkErrorsAndWarningsService.singleCustomsErrorNoLabel',
    defaultMessage: 'This shipment does not have Customs Forms because the label has not been purchased.',
    id: '3EwE+O',
  },
  singleCustomsErrorDomesticShipment: {
    description: 'bulkErrorsAndWarningsService.singleCustomsErrorDomesticShipment',
    defaultMessage: 'This shipment does not have Customs Forms because it is a domestic shipment.',
    id: 'vU9TCA',
  },
  singleCustomsErrorFormOnLabel: {
    description: 'bulkErrorsAndWarningsService.singleCustomsErrorFormOnLabel',
    defaultMessage: 'This shipment has Customs Forms attached to its shipping label.',
    id: 'cIVxU4',
  },
  batchErrors: {
    description: 'bulkErrorsAndWarningsService.batchErrors',
    defaultMessage: 'There are problems creating labels for these shipments. They will be excluded from processing the rest of the batch.',
    id: 'lHfJm9',
  },
  batchWarnings: {
    description: 'bulkErrorsAndWarningsService.batchWarnings',
    defaultMessage:
      'Some of the shipments in this batch need your attention. Please remove any that you do not wish to continue with. Any left will be included in processing the batch.',
    id: 'uzwKlY',
  },
  alreadyActiveLabels: {
    description: 'bulkErrorsAndWarningsService.alreadyActive',
    defaultMessage: 'Some of the selected shipments already have active labels and will be excluded from purchase',
    id: 'ZWPUgn',
  },
  batchLabelPrintWarning: {
    description: 'bulkErrorsAndWarningsService.batchLabelPrintWarning',
    defaultMessage:
      'Some of the selected labels have already been printed. Continue to reprint them, or you can skip the previously printed ones.',
    id: 'vUb7u9',
  },
  batchPackingSlipPrintWarning: {
    description: 'bulkErrorsAndWarningsService.batchPackingSlipPrintWarning',
    defaultMessage:
      'Some of the selected packing slips have already been printed. Continue to reprint them, or you can skip the previously printed ones.',
    id: 'k4Tvvk',
  },
  shipmentErrors: {
    description: 'bulkErrorsAndWarningsService.shipmentErrors',
    defaultMessage: 'Shipment Errors',
    id: 'SlUn0t',
  },
  fulfillmentPlanAssignmentErrorTitle: {
    description: 'bulkErrorsAndWarningsService.fulfillmentPlanAssignmentErrorTitle',
    defaultMessage: 'The selected shipments could not be assigned.',
    id: 'EOlr7w',
  },
  fulfillmentPlanAssignmentError: {
    description: 'bulkErrorsAndWarningsService.fulfillmentPlanAssignmentError',
    defaultMessage: 'This shipment is part of a batch assigned to {assignedUserName}',
    id: 'Br+90Y',
  },
  activeLabel: {
    description: 'bulkErrorsAndWarningsService.activeLabel',
    defaultMessage: 'Active Label',
    id: 'Mxg2gK',
  },
  noShipFromOrderLabelError: {
    description: 'bulkErrorsAndWarningsService.noShipFromOrderLabelError',
    defaultMessage: 'No Ship From has been selected.',
    id: 'xkWNXG',
  },
});
